// extracted by mini-css-extract-plugin
export default {"form":"styles_form__REzqz","formLayout":"styles_formLayout__rnkyz"};